import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { NoxoStatusChip } from '@noxo/ui/badge';
import { NoxoIcon } from '@noxo/ui/icon';
import { NoxoListRow, NoxoListRowCaption, NoxoListRowTitle } from '@noxo/ui/list-row';

import type { DemoJourney } from './demo-journey';

@Component({
  selector: 'noxo-demo-journey-list',
  imports: [NoxoIcon, NoxoListRow, NoxoListRowCaption, NoxoListRowTitle, NoxoStatusChip],
  template: `
    @for (journey of journeys(); track journey.label) {
      <button
        type="button"
        noxo-list-row
        size="s"
        tone="brand"
        [disabled]="busy() || journey.later !== undefined"
        (click)="picked.emit(journey)">
        <noxo-icon [icon]="journey.icon" />
        <noxo-list-row-title>{{ journey.label }}</noxo-list-row-title>
        <noxo-list-row-caption>{{ journey.caption }}</noxo-list-row-caption>
        @if (journey.later; as later) {
          <noxo-status-chip noxoListRowTrailing>Later · {{ later }}</noxo-status-chip>
        } @else {
          <noxo-icon
            icon="angle-right"
            trailing />
        }
      </button>
    }
  `,
  styles: ':host { display: flex; flex-direction: column; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoJourneyList {
  public readonly journeys = input.required<readonly DemoJourney[]>();
  public readonly busy = input(false);
  public readonly picked = output<DemoJourney>();
}
